import React from 'react';

const Header = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container">
                <a className="navbar-brand" href="#">
                    <img src="assets/images/logo.png" alt="logo" height="71" />
                </a>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <a className="nav-link" href="#/products/men">MEN</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/products/women">WOMEN</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/products/accessories">ACCESSORIES</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#/cart">CARTS(0)</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;
